import { getIsQuizOpen } from '@bridebook/web/lib/quiz/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const CakesQuizLazy = lazyComponent(() => import('./cakes-quiz'));

const CakesQuiz = () => {
  const isQuizOpen = useSelector(getIsQuizOpen('cake'));

  if (!isQuizOpen) {
    return null;
  }

  return <CakesQuizLazy />;
};

export default CakesQuiz;
